"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getClampedEndTime", {
  enumerable: true,
  get: function get() {
    return _getClampedEndTime["default"];
  }
});
Object.defineProperty(exports, "getVideoRelativeFrameIndicesAndTimesForFrame", {
  enumerable: true,
  get: function get() {
    return _getVideoRelativeFrameIndicesAndTimesForFrame["default"];
  }
});

var _getClampedEndTime = _interopRequireDefault(require("./getClampedEndTime"));

var _getVideoRelativeFrameIndicesAndTimesForFrame = _interopRequireDefault(require("./getVideoRelativeFrameIndicesAndTimesForFrame"));